import type { CareerSweepStatus } from "@/services/adminApi";

/** Poll interval of the career sweep card while the sweep is not finished. */
export const CAREER_SWEEP_POLL_MS = 15000;

export const CAREER_SWEEP_PHASE_BADGE: Record<string, { label: string; className: string }> = {
  companies: { label: "Classement des entreprises", className: "bg-blue-100 text-blue-700" },
  candidates: { label: "Recalcul des candidats", className: "bg-blue-100 text-blue-700" },
  reindex: { label: "Reindexation Elasticsearch", className: "bg-blue-100 text-blue-700" },
  done: { label: "Termine", className: "bg-green-100 text-green-700" },
  none: { label: "Pas encore demarre", className: "bg-gray-100 text-gray-700" },
};

export function careerSweepBadge(phase: string | null | undefined) {
  return CAREER_SWEEP_PHASE_BADGE[phase ?? "none"] ?? CAREER_SWEEP_PHASE_BADGE.none;
}

/** 0..1 progress -> integer percentage clamped to 0..100. */
export function toPercent(progress: number | null | undefined): number {
  if (progress == null || Number.isNaN(progress)) return 0;
  return Math.round(Math.min(1, Math.max(0, progress)) * 100);
}

/** "25 / 100 (25 %)" — the share is omitted when the total is 0. */
export function formatCoverage(part: number, total: number): string {
  const fmt = (n: number) => n.toLocaleString("fr-FR");
  if (!total) return `${fmt(part)} / ${fmt(total)}`;
  return `${fmt(part)} / ${fmt(total)} (${Math.round((part / total) * 100)} %)`;
}

/** The sweep still has work to do (or has never run): keep polling. */
export function isCareerSweepActive(status: CareerSweepStatus | null): boolean {
  return status?.phase !== "done";
}
